import { deepClone } from "@/utils";
import { Pay_GetConfig } from '@/api/transaction'
const state = {
  billParams: {},
  arrearsBill: [],
  arrearsFSBill: [],
  PayConfig: {}
};

const mutations = {
  // 加载支付配置
  SET_PAY_CONFIG: (state, data) => {
    state.PayConfig = deepClone(data);
  },
  // 设置临停订单详情查询条件
  SET_BILL_PARAMS: (state, data) => {
    state.billParams = deepClone(data);
  },
  // 保存欠费订单
  SET_ARREARS_BILL: (state, data) => {
    state.arrearsBill = deepClone(data);
  },
  SET_FS_ARREARS_BILL: (state, data) => {
    console.log(data)
    state.arrearsFSBill = []
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      let obj = {
        platformId: element.id,
        billingStatus: element.billingStatus,
        cardNumber: element.cardNumber,
        parkId: element.parkId,
        parkName: element.parkDesc,
        orderType: element.orderType,
        orderStatus: element.orderStatus,
        //orderPayTime: element.billingStatus,
        //zfbUserid: element.billingStatus,
        //wxOpenid: element.billingStatus,
        //otherId: element.billingStatus,
        //platformUserid: element.billingStatus,
        chargeMoney: element.chargeMoney,
        paidMoney: element.paidMoney,
        discountMoney: element.discountMoney,
        // payType: element.payType,
        isParkingOrRoadside: 2,
        isJfOrQfbj: "QFBJ",
        isFieldOrDoorway: "场内缴费",
        operateId: element.operatorId,
      }
      state.arrearsFSBill.push(obj)
    }
  }
};

const actions = {
  SetPayconfig ({ commit }, params) {
    return new Promise((resolve, reject) => {
      Pay_GetConfig(params)
        .then(res => {
          const data = res.body;
          commit("SET_PAY_CONFIG", data);
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
